import { Badge, BadgeProps } from '@mui/material';
import { styled } from '@mui/system';

import { COLORS } from '@/styles/tokens/colors';

export type UnreadIndicatorProps = BadgeProps & {
  /** Whether to show the unread indicator */
  show?: boolean;
};

/**
 * @description UnreadIndicator is a smaller, more subtle indicator for unread notifications.
 * It wraps another component and adds a small dot badge to indicate unread status.
 * Always uses MUI's `variant="dot"` so we don't need badgeContent.
 */
const BaseUnreadBadge = ({ show = true, ...rest }: UnreadIndicatorProps) => (
  <Badge {...rest} variant="dot" invisible={!show} overlap="circular" />
);

export const UnreadIndicator = styled(BaseUnreadBadge)(({}) => ({
  '& .MuiBadge-badge': {
    right: 2,
    top: 2,
    fontSize: 0,
    height: 8,
    width: 8,
    minWidth: 8,
    borderRadius: '50%',
    padding: 0,
    pointerEvents: 'none',
    display: 'inline-block',
    transform: 'translate(50%, -50%)',
    content: '""',
    backgroundColor: COLORS.ORANGE[500],
  },
}));
